import { render } from "./TextIconConfiger.vue?vue&type=template&id=4412d35c&scoped=true"
import script from "./TextIconConfiger.vue?vue&type=script&lang=js"
export * from "./TextIconConfiger.vue?vue&type=script&lang=js"

import "./TextIconConfiger.vue?vue&type=style&index=0&id=4412d35c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4412d35c"]])

export default __exports__